<app-admin-time-list *ngIf="!AdminTimeEditList" [ListATInputProperty]="isListorUpdateView"
    (ListOutputzat)="EmitChildComponent($event)"></app-admin-time-list>

    
<app-admin-time-edit *ngIf="AdminTimeEditList" [EditATInputProperty]="isListorUpdateView"
    (EditOutputAT)="EmitChildComponent($event)"></app-admin-time-edit>